import {useDispatch, useSelector} from 'react-redux'
import classNames from 'classnames'
import {setActiveTimeIndex} from '../../../stores/monitoring'

const ChooseTime = ({filters, onChange, setIsFiltering}) => {
    const activeTimeIndex = useSelector(state => state.monitoring.activeTimeIndex)
    const rangeSelected = useSelector(state => state.monitoring.rangeSelected)
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const dispatch = useDispatch()

    const handleChange = (item, index) => {
        dispatch(setActiveTimeIndex(index))
        setIsFiltering && setIsFiltering(prev => !prev)
        onChange({interval: item?.key})
    }

    const generateTimes = () => {
        return filters.map((item, index) => (
            <label className={classNames('radio-label', {
                dark: isDarkMode
            })} key={index}>
                <input type="radio" name="radio" checked={index === activeTimeIndex && !rangeSelected}
                    onChange={() => handleChange(item, index)}/>
                <span className="checkmark">{item.text}</span>
            </label>
        ))
    }
    return (
        <div className={classNames('choose-time', {
            dark: isDarkMode
        })}>
            {generateTimes()}
        </div>
    )
}

export default ChooseTime
